export const regexPassword = value => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true
  }
  return /^(?=.*?[a-z])(?=.*?\d)[a-z\d]{10,}$/i.test(value)
}

export const regexPostCode = value => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true
  }
  return /^([0-9]{7})$/.test(value)
}

export const regexFirstTel = value => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true
  }
  console.log(value)
  return /^([0-9]{3})$/.test(value)
}

export const regexSecondTel = value => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true
  }
  console.log(value)
  return /^([0-9]{4})$/.test(value)
}

export const beforeToday = value => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true
  }
  let month = value.month
  if (month === 0) {
    month = 0
  } else {
    month = month - 1
  }
  return new Date(value.year, month, value.day) <= new Date()
}
